import React from 'react';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { ServicesBookingFeedback } from '@components/templates';

export function ServicesBookingFeedbackPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('services-booking-feedback-component.metatags.title'),
        description: t('services-booking-feedback-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.servicesBookingFeedback,
        index: false,
    });

    return <ServicesBookingFeedback />;
}
